export const SET_INCOME_CLIENT_IDS = 'setIncomeClientIds';
export const SET_INCOME_CATEGORY = 'setIncomeCategory';
export const SET_INCOME_TYPE = 'setIncomeType';
export const SET_INCOME_DESCRIPTION = 'setIncomeDescription';
export const SET_INCOME_VALUE = 'setIncomeValue';
export const SET_INCOME_IS_GROSS = 'setIncomeIsGross';
export const SET_INCOME_FREQUENCY = 'setIncomeFrequency';
export const SET_INCOME_EMPLOYMENT_ID = 'setIncomeEmploymentId';
export const SET_INCOME_ERROR = 'setIncomeError';
